import { Link } from "react-router-dom";

export const Home = () => {
  return (
    <div className="home">
      <Link to="/gallery" className="canvas emoji">
        <div>gallery</div> <p>🧱</p>{" "}
      </Link>
      <Link to="/radiogospel" className="canvas emoji">
        radiogospel <p>📡</p>{" "}
      </Link>
      <Link to="/contact" className="canvas emoji">
        contakt <p>📱</p>{" "}
      </Link>
      <Link to="/projekts" className="canvas emoji">
        Projekts <p>🏗️</p>
      </Link>
    </div>
  );
};
